<template>
    <div id="searchResults" class="search-results-container" :class="{'quick-search': searchType === 'Smart'}">
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">
                <div class="pageHeader row">
                    <div class="col-8">
                        <div class="title-container">
                            <div class="page-title">Publication Results
                            </div>
                            <div class="sub-title" v-if="publicationResults">
                                {{publicationsNote}}
                                <div class="sub-note"> {{subNote}}
                                </div>
                            </div>
                            <div v-if="countLoader" class="loading"><span class="loader">Loading...</span></div>
                        </div>
                        <div class="nonNIH-note" v-if="publicationResults && publicationResults.results && publicationResults.results.length > 0"> {{nonNIHMsg}}
                    </div>
                    </div>
                    <div class="col-4">
                        <div class="action-buttons text-end">

                            <b-button variant="light"
                                @click.prevent="initExport()"
                                :disabled="!publicationResults || !publicationResults.results || publicationResults.results.length == 0"
                                :class="{'disabled': !publicationResults || !publicationResults.results || publicationResults.results.length == 0}">
                                    <i class="fas fa-download"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Export</span>
                                    <div class="loader export-loader" v-if="isExportingFile"></div>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <pubSearchFacets class="" ref="facets" v-if="!!publicationResults" />
                <div class="content-with-sidebar" >
                    <div class="field-error-message error-large" v-if="serviceError">
                        Unable to load publication data
                        <div class="error-code">
                        {{serviceError}}
                        </div>
                    </div>
                    <div v-if="!publicationResults && publicationResultsTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                    <publicationResultsTable class="dataTable"
                        :table="publicationResultsTable"
                        fromPage="publications-search"
                        ref="dataTable"
                        v-if="publicationResults" />
                </div>
            </div>
        </div>

        <!-- Export -->
        <exportModule ref="exportModule" fromPage="publications" />

    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import publicationResultsTable from '@/components/global/pubDataTable.vue';
import Charts from '@/components/global/Charts.vue';
import PubSearchFacets from '@/components/global/PubSearchFacets.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import bus from '@/shared/event-bus.js';

export default {
    name: 'PublicationResults',
    mixins: [globalMixins, projectListMixins],
    components: {
      publicationResultsTable,
      PubSearchFacets,
      Charts,
      exportModule
    },
    computed: {
        ...mapGetters([
            'searchCriteria',
            'editSearchCriteria',
            'searchMeta',
            'publicationsFacetData',
            'publicationResults',
            'isExportingFile',
            'coreProjCountPub'
        ]),
      publicationsNote: function () {
        if (this.publicationResults != null && this.publicationResults.meta) {
          if (this.publicationResults.meta.total) {
            var text = addCommas(this.publicationResults.meta.total),
              criteria = window.parseCriteria(this.$store.state.searchCriteria, {});

            text += ' Publication' + (this.publicationResults.meta.total !== 1 ? 's' : '');

            return text;
          }
          return '';
        }
      }
    },
    data: function () {
        return {
            serverless: false,
            data: null,
            serviceError: null,
            subNote: null,
            nonNIHMsg: null,
            countLoader: false
        };
    },
    watch: {
        publicationResults: function () {
            if (this.publicationResults === null) {
                this.setCoreProjCountPub(null);
            } else if (this.publicationResults !== null && !this.coreProjCountPub) {
                this.getCoreProjectsCount();
                this.getNonNIHPubCount();
            }
        }
    },
    mounted () {
        var loadData = false,
            facetToQueryStr;

        window.scrollTo(0, 0);
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            this.$router.push({ path: '/' }).catch(err => {});
        } else {
            this.showCriteria = false;
            if (this.$store.state.publicationsFacetCriteria && this.$store.state.publicationsFacetCriteria['publication_years'] && this.$store.state.publicationsFacetCriteria['publication_years'].length > 0) {
                loadData = true;
                this.$store.state.publicationsFacetCriteria['publication_years'] = [];
            }
            if (!this.publicationResults || loadData) {
                this.publicationResultsTable.isLoading = true;
                if (this.$route.query.sort_field) {
                    this.publicationResultsTable.sortField = this.$route.query.sort_field;
                }
                if (this.$route.query.sort_order) {
                    this.publicationResultsTable.sortOrder = this.$route.query.sort_order;
                }
                if (this.$route.query) {
                    this.parseFacetFiltersFromURL();
                }
                this.getPublicationSearchResults(false);
            } else {
                if (this.publicationResults.meta.sort_field) {
                    this.publicationResultsTable.sortField = this.publicationResults.meta.sort_field;
                    this.publicationResultsTable.sortOrder = this.publicationResults.meta.sort_order;

                    facetToQueryStr = this.$refs.facets.generateQueryString();
                    facetToQueryStr['sort_field'] = this.publicationResultsTable.sortField;
                    facetToQueryStr['sort_order'] = this.publicationResultsTable.sortOrder;
                    this.$router.push({ query: facetToQueryStr}).catch(err => {});
                }
                this.getCoreProjectsCount();
                this.getNonNIHPubCount();
            }
            bus.$off('get-applId');
            bus.$on('get-applId', (data, callback) => {
                this.getApplId(data, callback)
            });
            bus.$off('sort-column');
            bus.$on('sort-column', ($e1, data) => {
                console.log('111')
                this.setSortDetails($e1, data)
            });
        }

        this.setFullscreen(true);
        setTimeout(() => {
            bus.$emit('update:resize');
        }, 1);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setPublicationResults',
            'setCoreProjCountPub'
        ]),
        initExport () {
            bus.$emit('export:init');
        },
        getCoreProjectsCount () {
            var parsedCriteria = window.parseCriteria(this.searchCriteria, {isSubmitForm: false}),
                criteria = window.stringifySearchCriteriaFields(parsedCriteria),
                searchParam = {
                    offset: this.publicationResultsTable.offset,
                    limit: this.publicationResultsTable.limit,
                    facet_filters: this.searchFacetCriteria,
                    criteria: criteria,
                    is_shared: this.$route.query['shared'] ? true : false,
                    CoreProjSortField: 'fiscal_year', // hardcoded to fetch top 10000 publications
                    CoreProjSortOrder: 'desc',
                    Cache_Id: this.publicationResults.meta.properties.CacheId
                },
                callback = (data) => {
                    this.setCoreProjCountPub(data.results[0]);
                    this.subNote = 'supported by ' + addCommas(this.coreProjCountPub) + ' core projects from all fiscal years';
                    this.countLoader = false;
                };

            if (this.$route.params.search_id) {
                searchParam['search_id'] = this.$route.params.search_id;
            }

            window.fetchPublicationCoreProjCount(searchParam, callback);
        },
        getNonNIHPubCount () {
            var parsedCriteria = window.parseCriteria(this.searchCriteria, {isSubmitForm: false}),
                criteria = window.stringifySearchCriteriaFields(parsedCriteria),
                searchParam = {
                    offset: this.publicationResultsTable.offset,
                    limit: this.publicationResultsTable.limit,
                    facet_filters: this.searchFacetCriteria,
                    criteria: criteria,
                    is_shared: this.$route.query['shared'] ? true : false,
                    CoreProjSortField: 'fiscal_year', // hardcoded to fetch top 10000 publications
                    CoreProjSortOrder: 'desc'
                },
                callback = (data) => {
                    var nonNIHPubCount = data.meta && data.meta.total ? data.meta.total : 0,
                        pmField = criteria.publications_field === 'pm_id' ? 'pmid' : 'pmc_id',
                        pmIDs = '';

                    if (nonNIHPubCount > 0) {
                        pmIDs = data.results[0];
                        this.nonNIHMsg = 'There were ' +  addCommas(nonNIHPubCount) + ' identifier(s) that did not match any NIH supported publications: ' + pmIDs;
                    }
                };

            if (this.$route.params.search_id) {
                searchParam['search_id'] = this.$route.params.search_id;
            }

            window.fetchNonNIHPublCount(searchParam, callback);
        },
        setSortDetails ($event, selectedSortColumn) {
            this.isLoading = true;
            this.publicationResultsTable.isLoading = true;
            this.setPublicationSortDetails(selectedSortColumn, 'publicationResultsTable', this.getSortedPublicationsResults);
        },
        getSortedPublicationsResults () {
            var self = this,
                sortedData = _.orderBy(self.$store.state.publicationResults.results, [
                    function (item) { return item[self.publicationResultsTable.sortField]; },
                    function (item) { return item[self.publicationResultsTable.sortField]; }
                ], [self.publicationResultsTable.sortOrder, "asc"]);

            self.setPublicationResults({
                meta: self.$store.state.publicationResults.meta,
                results: sortedData,
                facet_results: self.$store.state.publicationResults.facet_results
            });
            if (self.$refs.dataTable) {
                self.$refs.dataTable.initTableData();
            }
            setTimeout(function () {
                self.isLoading = false;
                self.publicationResultsTable.isLoading = false;
            }, 100);
        },
        setProjectPageNumber () {
            if (this.$store.state.publicationResults.meta.total > this.publicationResultsTable.offset + this.publicationResultsTable.limit) {
                this.publicationResultsTable.loadingMoreData = true;
                this.publicationResultsTable.offset += this.publicationResultsTable.limit;
                this.getPublicationSearchResults(false);
            }
            // this.setPublicationPageNumber(fieldName);
        },
        exportData (selectedFieldsToExport, callback) {
            var searchParam,
                criteria = copyData(this.$refs.facets.publicationsFacetCriteria);

            if (!criteria['publication_years'] || (criteria['publication_years'] && criteria['publication_years'].length === 0)) {
                criteria['publication_years'] = this.$refs.facets.publicationsFacetData.facets[0].values.map((item) => {
                    return item.value;
                });
            }
            searchParam = {
                "search_id": this.$route.params.search_id,
                "facet_filters": criteria,
                "file_format": this.$refs.exportModule.exportFileFormat,
                "offset": 0,
                "limit": 0,
                "sort_field": this.publicationResultsTable.sortField,
                "sort_order": this.publicationResultsTable.sortOrder
            }
            this.getExportFile(searchParam, callback);
        },
        scrollToResultsTop () {
            let resultsOffsetTop = this.getResultsContainerOffsetTop();

            // only scroll up if user view is scrolled below top of table
            if (window.pageYOffset > resultsOffsetTop) {
                window.scrollTo(0, this.getResultsContainerOffsetTop());
            }
        },
        getResultsContainerOffsetTop () {
            return this.$refs.resultsContainer ? this.$refs.resultsContainer.offsetTop : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.nonNIH-note {
    position: absolute;
    right: 0;
    bottom: 12px;
    width: 70%;
    font-size: 13px;
}

.title-container {
    position: relative;
    min-height: 70px;
    .loader {
        top: 6px;
        height: 7em;
        width: 7em;
        left: 5%;
    }
}

.search-criteria-page {
    width: calc(100% - 265px);
}

.feature-area {
    width: 100%;
    .search-results-section {
        width: 265px;
    }
}

</style>
